module.exports = __webpack_public_path__ + "img/V97.0a83138d.jpg";